import {createContext, useCallback, useContext, useMemo} from 'react';
import ApiClient from '../core/ApiClient';
import useTranslation from "../hooks/translations";
import {toast} from "react-toastify";

const ApiContext = createContext();

export default function ApiProvider({children}) {
  const translations = useTranslation()

  const onError = useCallback((response) => {
    let message = "";
    if (response.status === 400) {
      message = translations.apiBadRequestError;
    } else if (response.status === 401) {
      message = translations.apiNotAuthorizedError;
    } else if (response.status === 403) {
      message = translations.apiForbiddenError;
    } else if (response.status === 404) {
      message = translations.apiNotFoundError;
    } else if (response.status === 409) {
      message = translations.apiConflictError;
    } else {
      message = translations.apiInternalServerError;
    }
    toast.error(message)
  }, []);

  const api = useMemo(() => new ApiClient(onError), [onError]);

  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi() {
  return useContext(ApiContext);
}
